export default function ProfileImage({ image }) {
  return (
    <div className="w-48 h-48 rounded-full mx-auto mt-8 mb-6 border-4 border-emerald-400/40 flex items-center justify-center bg-cover bg-center bg-no-repeat" style={{ backgroundImage: `url('/assets/images/me.jpeg')`}}>
    </div>
  );
}